import axios from 'axios';

const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + process.env.REACT_APP_FASTFILE_API_TOKEN,
};

const SERVER_ROOT = 'https://api.opensight.ai/';
const LOCAL_ROOT = 'http://localhost:4300/';
const URL = process.env.NODE_ENV === 'development' ? LOCAL_ROOT : SERVER_ROOT;

export async function get(path, params) {
  return new Promise(function (resolve, reject) {
    axios
      .get(URL + path, {
        params: params,
        headers: HEADERS,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function post(path, params) {
  return new Promise(function (resolve, reject) {
    axios
      .post(
        URL + path,
        {
          params: params,
        },
        { headers: HEADERS },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
